import { useMutation, useQueryClient } from '@tanstack/react-query';
import { userKeys, userOptions } from '../../constants/user';
export function useUserActions() {
    const queryClient = useQueryClient();
    const getMe = async () => {
        return (await queryClient.fetchQuery(userOptions.me())) ?? undefined;
    };
    const requestCodeMutation = useMutation(userOptions.requestCode());
    const validateCodeMutation = useMutation(userOptions.validateCode());
    const validatePasswordMutation = useMutation(userOptions.validatePassword());
    const finalizeCodeMutation = useMutation(userOptions.finalizeCode());
    const consumeImpersonationTokenMutation = useMutation(userOptions.consumeImpersonationToken());
    const generateHandoffTokenMutation = useMutation(userOptions.generateHandoffToken());
    const consumeHandoffTokenMutation = useMutation(userOptions.consumeHandoffToken());
    const registerAsGuestMutation = useMutation(userOptions.registerAsGuest());
    const convertTemporaryUserMutation = useMutation(userOptions.convertTemporaryUser());
    const updateMutation = useMutation({
        ...userOptions.update(),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: userKeys.all });
        },
    });
    const registerAsPartnerMutation = useMutation({
        ...userOptions.registerAsPartner(),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: userKeys.all });
        },
    });
    const applyReferralCodeMutation = useMutation({
        ...userOptions.applyReferralCode(),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: userKeys.all });
        },
    });
    const confirmReverificationMutation = useMutation(userOptions.confirmReverification());
    const updateLoginMethodMutation = useMutation({
        ...userOptions.updateLoginMethod(),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: userKeys.all });
        },
    });
    const requestPasswordResetMutation = useMutation(userOptions.requestPasswordReset());
    const resetPasswordMutation = useMutation(userOptions.resetPassword());
    return {
        getMe,
        requestCode: requestCodeMutation.mutateAsync,
        validateCode: validateCodeMutation.mutateAsync,
        validatePassword: validatePasswordMutation.mutateAsync,
        finalizeCode: finalizeCodeMutation.mutateAsync,
        consumeImpersonationToken: consumeImpersonationTokenMutation.mutateAsync,
        generateHandoffToken: generateHandoffTokenMutation.mutateAsync,
        consumeHandoffToken: consumeHandoffTokenMutation.mutateAsync,
        registerAsGuest: registerAsGuestMutation.mutateAsync,
        convertTemporaryUser: convertTemporaryUserMutation.mutateAsync,
        updateUser: updateMutation.mutateAsync,
        registerAsPartner: registerAsPartnerMutation.mutateAsync,
        applyReferralCode: applyReferralCodeMutation.mutateAsync,
        confirmReverification: confirmReverificationMutation.mutateAsync,
        updateLoginMethod: updateLoginMethodMutation.mutateAsync,
        requestPasswordReset: requestPasswordResetMutation.mutateAsync,
        resetPassword: resetPasswordMutation.mutateAsync,
        requesting: requestCodeMutation.isPending,
        validating: validateCodeMutation.isPending,
        validatingPassword: validatePasswordMutation.isPending,
        finalizing: finalizeCodeMutation.isPending,
        consumingImpersonationToken: consumeImpersonationTokenMutation.isPending,
        generatingHandoffToken: generateHandoffTokenMutation.isPending,
        consumingHandoffToken: consumeHandoffTokenMutation.isPending,
        registeringAsGuest: registerAsGuestMutation.isPending,
        convertingTemporaryUser: convertTemporaryUserMutation.isPending,
        updatingUser: updateMutation.isPending,
        registeringAsPartner: registerAsPartnerMutation.isPending,
        applyingReferralCode: applyReferralCodeMutation.isPending,
        confirmingReverification: confirmReverificationMutation.isPending,
        updatingLoginMethod: updateLoginMethodMutation.isPending,
        requestingPasswordReset: requestPasswordResetMutation.isPending,
        resettingPassword: resetPasswordMutation.isPending,
    };
}
